import {
  ExtractDocumentTypeFromTypedRxJsonSchema,
  RxJsonSchema,
  toTypedRxJsonSchema,
} from 'rxdb'

export const appUser = {
  version: 0,
  title: 'AppUser',
  primaryKey: 'rowId',
  type: 'object',
  properties: {
    rowId: {
      maxLength: 36,
      type: 'string',
    },
    name: {
      type: 'string',
    },
    emailAddress: {
      type: 'string',
    },
    updatedAt: {
      type: 'string',
    },
  },
  required: ['rowId', 'name', 'emailAddress', 'updatedAt'],
} as const

const schemaTyped = toTypedRxJsonSchema(appUser)

export type AppUser = ExtractDocumentTypeFromTypedRxJsonSchema<
  typeof schemaTyped
>

export const appUserSchema: RxJsonSchema<AppUser> = appUser
